// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const SettingsUpdateIn = zod.object({
  "values": zod.record(zod.string(), zod.unknown())
});

export type SettingsUpdateIn = zod.input<typeof SettingsUpdateIn>;
export type SettingsUpdateInOutput = zod.output<typeof SettingsUpdateIn>;
